import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  const updated = "January 2026";
  return (
    <main className="max-w-3xl mx-auto px-6 py-12 prose prose-slate" data-testid="terms-page">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[color:var(--brand-primary)] mb-6 no-underline">
        <ArrowLeft className="w-4 h-4"/> Back to home
      </Link>
      <p className="font-overline text-xs" style={{ color: "var(--brand-secondary)" }}>Legal</p>
      <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-2" style={{ color: "var(--brand-primary)" }}>Terms of Service</h1>
      <p className="text-slate-500 text-sm">Last updated: {updated}</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using this sports record book platform ("the Service"), you agree to these Terms of Service. If you do not agree, please do not use the Service.</p>

      <h2>2. Description of the Service</h2>
      <p>The Service is an online record book that displays historical and current athletic records submitted and maintained by an athletic association, school district, or high school athletic staff. Records include, among other data, event names, athlete or team names, school names, years, and statistical results.</p>

      <h2>3. User Roles & Accounts</h2>
      <ul>
        <li><strong>Public visitors</strong> may browse published records and download reports.</li>
        <li><strong>Coaches</strong> may submit new records for administrative approval.</li>
        <li><strong>Athletic Directors</strong> may submit records and approve pending submissions.</li>
        <li><strong>Super Admins</strong> have full access to configuration, users, and content.</li>
      </ul>
      <p>Administrator accounts are provisioned by the operator of the Service. You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account.</p>

      <h2>4. Accuracy of Data</h2>
      <p>We strive to publish accurate historical athletic records. However, records are user-submitted and may contain errors, omissions, or disputed values. Data is provided "as is" without warranty of accuracy or completeness. If you spot an issue, please use the contact information in the footer to suggest a correction.</p>

      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Attempt to access accounts, records, or administrative functions that you are not authorized to use.</li>
        <li>Scrape, copy, or redistribute records in a way that misrepresents the source or purpose.</li>
        <li>Submit or upload content that is unlawful, defamatory, or that infringes on any third party's rights.</li>
        <li>Interfere with, disrupt, or attempt to gain unauthorized access to any part of the Service.</li>
      </ul>

      <h2>6. Content Ownership</h2>
      <p>The historical facts represented (athlete names, scores, years) are matters of public sports record. The specific presentation, organization, branding, software, and derivative rankings on this Service are the property of the Service operator. You may print, download, and share individual records for non-commercial personal, educational, or journalistic use with attribution.</p>

      <h2>7. Corrections & Removals</h2>
      <p>To request a correction, addition, or removal of a record, please contact the site administrator using the email address in the footer. Reasonable requests supported by evidence will generally be honored.</p>

      <h2>8. Third-Party Links</h2>
      <p>The Service may include links to third-party websites (school pages, social media). We are not responsible for the content or policies of those sites.</p>

      <h2>9. Disclaimer of Warranties</h2>
      <p>The Service is provided on an "as is" and "as available" basis without warranties of any kind, express or implied, including warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>

      <h2>10. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, the operator of the Service shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Service.</p>

      <h2>11. Changes to the Service or Terms</h2>
      <p>We may update these Terms of Service at any time. Updates will be posted on this page with a revised "Last updated" date. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>

      <h2>12. Contact</h2>
      <p>For questions about these Terms, please contact the site administrator using the email address in the footer.</p>
    </main>
  );
}
